export var getCursorCoordinates = function (textareaEl, containerEl) {
    var mirror = document.createElement('div');
    var style = getComputedStyle(textareaEl);
    var styleProps = [
        'boxSizing', 'width', 'height', 'padding', 'border',
        'fontFamily', 'fontSize', 'fontWeight', 'lineHeight',
        'letterSpacing', 'whiteSpace', 'wordBreak', 'overflowWrap'
    ];
    styleProps.forEach(function (prop) {
        mirror.style[prop] = style[prop];
    });
    var textareaRect = textareaEl.getBoundingClientRect();
    mirror.style.position = 'fixed';
    mirror.style.top = "".concat(textareaRect.top, "px");
    mirror.style.left = "".concat(textareaRect.left, "px");
    mirror.style.whiteSpace = 'pre-wrap';
    mirror.style.visibility = 'hidden';
    var text = textareaEl.value;
    mirror.textContent = text;
    document.body.appendChild(mirror);
    var textNode = mirror.firstChild;
    var range = document.createRange();
    var start = textareaEl.selectionStart;
    var end = textareaEl.selectionEnd;
    range.setStart(textNode, start);
    range.setEnd(textNode, end);
    var rect = range.getBoundingClientRect();
    var containerRect = containerEl.getBoundingClientRect();
    document.body.removeChild(mirror);
    return {
        x: rect.left + (rect.width / 2) - containerRect.left,
        y: rect.top - containerRect.top
    };
};
//# sourceMappingURL=getCursorCoordinates.js.mapexport var getCursorCoordinates = function (textareaEl, containerEl) {
    var mirror = document.createElement('div');
    var style = getComputedStyle(textareaEl);
    var styleProps = [
        'boxSizing', 'width', 'height', 'padding', 'border',
        'fontFamily', 'fontSize', 'fontWeight', 'lineHeight',
        'letterSpacing', 'whiteSpace', 'wordBreak', 'overflowWrap'
    ];
    styleProps.forEach(function (prop) {
        mirror.style[prop] = style[prop];
    });
    var textareaRect = textareaEl.getBoundingClientRect();
    mirror.style.position = 'fixed';
    mirror.style.top = "".concat(textareaRect.top, "px");
    mirror.style.left = "".concat(textareaRect.left, "px");
    mirror.style.whiteSpace = 'pre-wrap';
    mirror.style.visibility = 'hidden';
    var text = textareaEl.value;
    mirror.textContent = text;
    document.body.appendChild(mirror);
    var textNode = mirror.firstChild;
    var range = document.createRange();
    var start = textareaEl.selectionStart;
    var end = textareaEl.selectionEnd;
    range.setStart(textNode, start);
    range.setEnd(textNode, end);
    var rect = range.getBoundingClientRect();
    var containerRect = containerEl.getBoundingClientRect();
    document.body.removeChild(mirror);
    return {
        x: rect.left + (rect.width / 2) - containerRect.left,
        y: rect.top - containerRect.top
    };
};
//# sourceMappingURL=getCursorCoordinates.js.map